import MockAdapter from 'axios-mock-adapter'
import { AxiosInstance, AxiosRequestConfig } from 'axios'
import { Mock } from 'types/global'
import { MocksServiceNow } from '__mocks__/servicenow'
import { MocksMicrosoftGraph } from '__mocks__/microsoftgraph'
import { MocksUserServiceNow } from '__mocks__/servicenow/user'
import { MocksLocationServiceNow } from '__mocks__/servicenow/location'
import { MocksSectorServiceNow } from '__mocks__/servicenow/sector'
/** Array de Mock com as informações de usuários do ServiceNow */
export const getMocksUserServiceNow = () => MocksUserServiceNow
/** Array de Mock com as informações de setores do ServiceNow */
export const getMocksSectorServiceNow = () => MocksSectorServiceNow
/** Array de Mock com as informações de unidades do ServiceNow */
export const getMocksLocationServiceNow = () => MocksLocationServiceNow
/** Array de Mock para request a Graph API */
export const getMocksMicrosoftGraph = () => MocksMicrosoftGraph
/** Array de Mock que crentraliza os arrays de TODOS os Arrays de Mock do pacote '__mocks__/servicenow' */
export const getMocksServiceNow = () => MocksServiceNow


//foi necessário criar o mock do axios aqui, pois o jest.mock('axios') não estava funcionando corretamente
if (typeof jest !== 'undefined') {
  jest.mock('axios', () => ({
    ...jest.requireActual('axios'),
    create: jest.fn(() => {
      return {
        interceptors: {
          request: { eject: jest.fn, use: jest.fn((config) => Promise.resolve()) },
          response: { eject: jest.fn, use: jest.fn(() => Promise.resolve()) },
        },
        defaults: { adapter: {} },
        post: jest.fn((url: string, data: any) => url),
        put: jest.fn((url: string, data: any, config?: AxiosRequestConfig<any>) => Promise.resolve({ data: [0] }))
        ,
        get: jest.fn((url: string, config?: AxiosRequestConfig<any>) => Promise.resolve({ data: { result: { stats: { count: 0 } } } }))
      }
    })
  }))
};


/**
 * Cria instancias de mocks para requests do Axios
 * @param mocks - Array de Mock com as informações method, url e data
 * @param axios - Instancia do Axios usada para mockar requests
 */
export const createAxiosMocks = (mocks:Mock[], axios:AxiosInstance) => {
    const mockAdapter = new MockAdapter(axios)
    for (var i = 0; i < mocks.length; i++) {
      let mock = mocks[i]
      switch (mock.method) {
        case 'POST':
          mockAdapter.onPost(mock.url).reply(200, mock.data)
          break
        case 'GET':
          mockAdapter.onGet(mock.url).reply(200, mock.data)
          break
        case 'PUT':
          mockAdapter.onPut(mock.url).reply(200, mock.data)
          break
        default:
          console.log('Mock não configurado corretamente')
          break
      }
    }
}

export function mockCsvReportFetch(data: any) {
  if (typeof jest !== 'undefined') {
    function mockFetch(data: any) {
      return jest.fn().mockImplementation(() =>
        Promise.resolve({
          ok: true,
          //can add blob etc and test csv
          blob: () => Promise.resolve({}),
          json: () => data,
    
        }),
      );
    }
    window.fetch = mockFetch(data);
  }
}